const White = {
  White: {
    _000: '#FFF',
    _100: '#FFF',
    _200: '#FFF',
    _300: '#FFF',
    _400: '#FFF',
    _500: '#FFF',
    _600: '#FFF',
    _700: '#FFF',
    _800: '#FFF',
    _900: '#FFF',
  },
};

export default White;
